var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/Edit"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("path",{"d":"M19.5,8.41500853 L11.2192083,16.6805003 L8.29880393,13.7654918 L16.5795956,5.5 L19.5,8.41500853 Z M6.24754378,15.5433485 L8.90580948,18.1738204 L5.5,19.5 L6.24754378,15.5433485 Z","id":"path-1","key":2})]);
}

Edit.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = Edit;

Edit.default = Edit;
